module.exports = __webpack_public_path__ + "img/img1.902183af.png";